export const TemplateMenuKeys = {
  OpenTemplate: 'openTemplate',
  TemplateProperties: 'templateProperties',
  ArchiveTemplate: 'archiveTemplate',
  DeleteTemplate: 'deleteTemplate',
} as const;
